export { SearchContentTable } from './SearchContentTable';
